var _defs, _path, _path2, _path3, _path4, _rect, _rect2, _circle, _circle2, _circle3, _circle4, _rect3, _rect4, _polygon, _rect5, _polygon2, _rect6, _rect7, _path5, _rect8, _path6, _circle5, _path7, _path8, _path9, _rect9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _rect0, _rect1, _line, _line2, _line3, _line4, _line5, _rect10, _line6, _line7, _line8, _line9, _line0, _rect11, _line1, _line10, _line11, _line12, _line13, _rect12, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _rect13, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _path16, _ellipse, _path17, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _path18, _path19, _line54, _line55, _line56, _line57, _path20, _line58, _line59, _line60, _line61, _rect48, _rect49, _polygon3, _path21, _line62, _rect50, _circle6, _line63, _path22, _path23, _rect51, _path24, _rect52, _circle7, _rect53, _rect54, _circle8, _circle9, _circle0, _circle1, _path25, _rect55, _rect56, _rect57, _rect58, _ellipse2, _rect59, _path26, _path27, _path28, _path29, _path30, _rect60, _line64, _line65, _rect61, _rect62, _rect63, _rect64, _polygon4, _polyline, _line66, _line67, _line68, _line69, _polyline2, _polyline3, _line70, _rect65, _ellipse3, _line71, _line72, _line73, _line74, _line75, _line76, _line77, _line78, _circle10, _path31, _path32, _polygon5, _circle11, _circle12, _line79, _line80, _line81, _line82, _line83, _line84, _rect66, _rect67, _rect68, _line85, _line86, _line87, _line88, _line89, _line90, _rect69, _rect70, _rect71, _rect72, _path33, _path34, _polygon6, _rect73, _path35, _path36, _rect74, _rect75, _rect76, _circle13, _line91, _path37, _line92, _line93, _line94, _line95, _path38, _path39, _polygon7, _polygon8, _path40, _polygon9, _path41, _polygon0, _path42, _line96, _line97, _line98, _line99, _path43, _path44, _circle14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMalfunctionsFrancisTurbinemiv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 918 612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n      .malfunction {\n        cursor: pointer;\n      }\n\n      .group {\n        cursor: pointer;\n      }\n      \n      .cls-1, .cls-10, .cls-13, .cls-16, .cls-17, .cls-19, .cls-2, .cls-20, .cls-21, .cls-23, .cls-7, .cls-9 {\n        fill: none;\n      }\n\n      .cls-1 {\n        stroke: #ddd;\n      }\n\n      .cls-1, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-2, .cls-20, .cls-21, .cls-22, .cls-23, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-9 {\n        stroke-width: 1.5px;\n      }\n\n      .cls-2 {\n        stroke: #9c9c9c;\n      }\n\n      .cls-3 {\n        fill: #9c9c9c;\n      }\n\n      .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-20, .cls-21, .cls-22, .cls-23, .cls-3, .cls-4, .cls-5, .cls-6, .cls-9 {\n        stroke: #202020;\n      }\n\n      .cls-14, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-22, .cls-5, .cls-8 {\n        fill: #ddd;\n      }\n\n      .cls-6 {\n        fill: #ededed;\n      }\n\n      .cls-7 {\n        stroke: #6f6f6f;\n      }\n\n      .cls-10 {\n        stroke: #ededed;\n      }\n\n      .cls-11, .cls-18 {\n        fill: #f6f6f6;\n      }\n\n      .cls-12 {\n        fill: #6f6f6f;\n      }\n\n      .cls-13, .cls-20, .cls-21, .cls-22, .cls-23 {\n        stroke-linecap: round;\n      }\n\n      .cls-14, .cls-20, .cls-21, .cls-22, .cls-23 {\n        stroke-linejoin: round;\n      }\n\n      .cls-15 {\n        fill: #202020;\n      }\n\n      .cls-16 {\n        stroke-dasharray: 2.08 2.08 2.08 2.08;\n      }\n\n      .cls-17 {\n        stroke-dasharray: 2.08 2.08 2.08 2.08 2.08 2.08;\n      }\n\n      .cls-21 {\n        stroke-dasharray: 0.02 4.05;\n      }\n\n      .cls-23 {\n        stroke-dasharray: 0.1 5.91;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M679.6,306H325.1a2.43,2.43,0,0,1-2.4-2.4h0V281.1a2.43,2.43,0,0,1,2.4-2.4h129a2.43,2.43,0,0,0,2.4-2.4h0v-9.4a2.43,2.43,0,0,0-2.4-2.4H287.6a2.43,2.43,0,0,1-2.4-2.4h0v-7.5a2.43,2.43,0,0,1,2.4-2.4h65.7a2.43,2.43,0,0,0,2.4-2.4h0V211.9a2.43,2.43,0,0,0-2.4-2.4H308.8a2.43,2.43,0,0,1-2.4-2.4h0v-35a2.43,2.43,0,0,0-2.4-2.4H276.2a2.37,2.37,0,0,1-2.4-2.4h0V145.8a2.37,2.37,0,0,1,2.4-2.4h47.1a2.43,2.43,0,0,0,2.4-2.4h0v-4.5a2.43,2.43,0,0,1,2.4-2.4h41.7a2.43,2.43,0,0,1,2.4,2.4h0V139a2.43,2.43,0,0,1-2.4,2.4H364a2.37,2.37,0,0,0-2.4,2.4h0v1.9a2.43,2.43,0,0,0,2.4,2.4h5.8a2.43,2.43,0,0,1,2.4,2.4h0V153a2.43,2.43,0,0,1-2.4,2.4H335.4a2.37,2.37,0,0,0-2.4,2.4h0v9.5a2.37,2.37,0,0,0,2.4,2.4H466.2a2.37,2.37,0,0,0,2.4-2.4h0V150.5a2.43,2.43,0,0,1,2.4-2.4h.8a2.43,2.43,0,0,1,2.4,2.4h0v23.1a2.43,2.43,0,0,1-2.4,2.4h-51a2.43,2.43,0,0,0-2.4,2.4h0V313.9a2.43,2.43,0,0,0,2.4,2.4H679.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.9,34c37.7,62.7,80.7,53.1,87.3,53.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.6,59.9c22.6,37.3,58.8,38.4,70.1,36"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M567.1,176.4v8.2a2.86,2.86,0,0,1-2.8,2.8H257.8a2.86,2.86,0,0,1-2.8-2.8V113.4a2.8,2.8,0,0,0-2.4-2.8c-7-1.1-27.6-5.6-36.4-22.9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 165.25,
    y: 183.13,
    width: 73.8,
    height: 3.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 162.45,
    y: 186.95,
    width: 79.3,
    height: 16.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 223.3,
    cy: 178.5,
    r: 4.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 211.2,
    cy: 178.5,
    r: 4.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 193.2,
    cy: 178.5,
    r: 4.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 181.1,
    cy: 178.5,
    r: 4.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 180.88,
    y: 115.38,
    width: 42.2,
    height: 58.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 223.29,
    y: 165.08,
    width: 10.8,
    height: 4.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "223.1 161.8 234.1 161.8 234.1 133 223.1 116 223.1 161.8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 170.2,
    y: 165.1,
    width: 10.8,
    height: 4.1
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "181 161.8 170.2 161.8 170.2 133 181 116 181 161.8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 180.88,
    y: 111.05,
    width: 42.2,
    height: 4.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 214.59,
    y: 86.93,
    width: 1.8,
    height: 24.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M215.4,104.2h0a3,3,0,0,0,3-3V92a3,3,0,0,0-3-3h0a3,3,0,0,0-3,3v9.2A3.08,3.08,0,0,0,215.4,104.2Z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 187.92,
    y: 95.41,
    width: 1.8,
    height: 15.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M188.8,107.1h0a3,3,0,0,0,3-3v-3.7a3,3,0,0,0-3-3h0a3,3,0,0,0-3,3v3.7A3,3,0,0,0,188.8,107.1Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 366.6,
    cy: 144.6,
    r: 17.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M811.6,436.5H296.8a46.35,46.35,0,0,1-27.4-9l-89.9-66.6-.6-.4c7.8-10.8,21.7-20.5,46.5-22.6,23.4-2,36.8-9.5,44.5-18.4l.4.3,44.4,31.7H811.9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M630.6,327.6H750.8a2.37,2.37,0,0,1,2.4,2.4h0v49.1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M620.1,285.9h8.1a2.43,2.43,0,0,1,2.4,2.4v90.8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    y: 142.5,
    width: 42.8,
    height: 209.1
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42.3,67.2V214.7h66a46,46,0,0,1,26.8,8.6l112.1,80.2h0c-7.8,8.7-21.2,16-44.2,18-24.6,2.1-38.5,11.7-46.3,22.4l-.1.1-40.3-29.8h-74v37.3H0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42.3,67.2V214.7h66a46,46,0,0,1,26.8,8.6l112.1,80.2h0c-7.8,8.7-21.2,16-44.2,18-24.6,2.1-38.5,11.7-46.3,22.4l-.1.1-40.3-29.8h-74v37.3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M169.1,394s-4.6-50.9,56.2-56.1c64.6-5.6,53.6-53.7,53.6-53.7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M146.9,377.8s-4.6-50.9,56.2-56.2c64.6-5.6,53.7-53.7,53.7-53.7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M702.4,58.6h48a2.37,2.37,0,0,1,2.4,2.4h0V79.5a2.43,2.43,0,0,1-2.4,2.4H729.8a2.43,2.43,0,0,0-2.4,2.4v4a2.43,2.43,0,0,0,2.4,2.4h20.6a2.43,2.43,0,0,1,2.4,2.4h0v95a2.43,2.43,0,0,1-2.4,2.4H727.2a2.43,2.43,0,0,0-2.4,2.4v14c0,1.3-1.1,3.2-2.4,3.2h-4.9a2.43,2.43,0,0,0-2.4,2.4h0V248a2.43,2.43,0,0,0,2.4,2.4h42.7a2.43,2.43,0,0,1,2.4,2.4v35.4a2.43,2.43,0,0,1-2.4,2.4H717.4A2.43,2.43,0,0,0,715,293h0v.5a2.43,2.43,0,0,0,2.4,2.4h7.2a2.43,2.43,0,0,1,2.4,2.4h0a2.43,2.43,0,0,1-2.4,2.4h-7.3a2.43,2.43,0,0,0-2.4,2.4h0V306a2.43,2.43,0,0,0,2.4,2.4h12.1a2.43,2.43,0,0,1,2.4,2.4h0v49.4a2.43,2.43,0,0,1-2.4,2.4h-5.6a2.43,2.43,0,0,0-2.4,2.4v8.8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M726.5,381.8h43.9l.1,24.6S744,407.2,739,425Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M644.1,425.1c-3.9-17.9-28.5-18.9-31.5-18.6l.1-24.6h45.5l-14.1,43.2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M739,425.1l11.8,91.2H632.2L644,425.1"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 756.2,
    y: 223.2,
    width: 22.3,
    height: 79
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 778.6,
    y: 223.2,
    width: 22.3,
    height: 79
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 783.3,
    y1: 236.7,
    x2: 796.2,
    y2: 236.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 783.3,
    y1: 241,
    x2: 796.2,
    y2: 241
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 783.3,
    y1: 245.4,
    x2: 796.2,
    y2: 245.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 783.3,
    y1: 249.7,
    x2: 796.2,
    y2: 249.7
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 778.6,
    y1: 262.8,
    x2: 801,
    y2: 262.8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 801,
    y: 223.2,
    width: 22.3,
    height: 79
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 805.7,
    y1: 236.7,
    x2: 818.6,
    y2: 236.7
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 805.7,
    y1: 241,
    x2: 818.6,
    y2: 241
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 805.7,
    y1: 245.4,
    x2: 818.6,
    y2: 245.4
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 805.7,
    y1: 249.7,
    x2: 818.6,
    y2: 249.7
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 801,
    y1: 262.8,
    x2: 823.3,
    y2: 262.8
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 823.3,
    y: 223.2,
    width: 22.3,
    height: 79
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 828,
    y1: 236.7,
    x2: 840.9,
    y2: 236.7
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 828,
    y1: 241,
    x2: 840.9,
    y2: 241
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 828,
    y1: 245.4,
    x2: 840.9,
    y2: 245.4
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 828,
    y1: 249.7,
    x2: 840.9,
    y2: 249.7
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 823.3,
    y1: 262.8,
    x2: 845.7,
    y2: 262.8
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 845.7,
    y: 223.2,
    width: 22.3,
    height: 79
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 850.4,
    y1: 236.7,
    x2: 863.3,
    y2: 236.7
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 850.4,
    y1: 241,
    x2: 863.3,
    y2: 241
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 850.4,
    y1: 245.4,
    x2: 863.3,
    y2: 245.4
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 850.4,
    y1: 249.7,
    x2: 863.3,
    y2: 249.7
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 783.3,
    y1: 275.7,
    x2: 796.2,
    y2: 275.7
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 783.3,
    y1: 280,
    x2: 796.2,
    y2: 280
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 783.3,
    y1: 284.4,
    x2: 796.2,
    y2: 284.4
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 783.3,
    y1: 288.7,
    x2: 796.2,
    y2: 288.7
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 761,
    y1: 236.7,
    x2: 773.9,
    y2: 236.7
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 761,
    y1: 241,
    x2: 773.9,
    y2: 241
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 761,
    y1: 245.4,
    x2: 773.9,
    y2: 245.4
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 761,
    y1: 249.7,
    x2: 773.9,
    y2: 249.7
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 756.2,
    y1: 262.8,
    x2: 778.6,
    y2: 262.8
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 761,
    y1: 275.7,
    x2: 773.9,
    y2: 275.7
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 761,
    y1: 280,
    x2: 773.9,
    y2: 280
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 761,
    y1: 284.4,
    x2: 773.9,
    y2: 284.4
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 761,
    y1: 288.7,
    x2: 773.9,
    y2: 288.7
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 805.7,
    y1: 275.7,
    x2: 818.6,
    y2: 275.7
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 805.7,
    y1: 280,
    x2: 818.6,
    y2: 280
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 805.7,
    y1: 284.4,
    x2: 818.6,
    y2: 284.4
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 805.7,
    y1: 288.7,
    x2: 818.6,
    y2: 288.7
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 828,
    y1: 275.7,
    x2: 840.9,
    y2: 275.7
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 828,
    y1: 280,
    x2: 840.9,
    y2: 280
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 828,
    y1: 284.4,
    x2: 840.9,
    y2: 284.4
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 828,
    y1: 288.7,
    x2: 840.9,
    y2: 288.7
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 850.4,
    y1: 275.7,
    x2: 863.3,
    y2: 275.7
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 850.4,
    y1: 280,
    x2: 863.3,
    y2: 280
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 850.4,
    y1: 284.4,
    x2: 863.3,
    y2: 284.4
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 850.4,
    y1: 288.7,
    x2: 863.3,
    y2: 288.7
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 845.7,
    y1: 262.8,
    x2: 868,
    y2: 262.8
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 868,
    y: 223.2,
    width: 22.3,
    height: 79
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 872.7,
    y1: 236.7,
    x2: 885.6,
    y2: 236.7
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 872.7,
    y1: 241,
    x2: 885.6,
    y2: 241
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 872.7,
    y1: 245.4,
    x2: 885.6,
    y2: 245.4
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 872.7,
    y1: 249.7,
    x2: 885.6,
    y2: 249.7
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 872.7,
    y1: 275.7,
    x2: 885.6,
    y2: 275.7
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 872.7,
    y1: 280,
    x2: 885.6,
    y2: 280
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 872.7,
    y1: 284.4,
    x2: 885.6,
    y2: 284.4
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 872.7,
    y1: 288.7,
    x2: 885.6,
    y2: 288.7
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 868,
    y1: 262.8,
    x2: 890.3,
    y2: 262.8
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 654.8,
    y1: 381.8,
    x2: 728,
    y2: 381.8
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 663.8,
    y: 338.1,
    width: 7.2,
    height: 20.1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 711.8,
    y: 338.1,
    width: 7.2,
    height: 20.1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 674.5,
    y: 338.1,
    width: 33.6,
    height: 25.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 656.3,
    y: 278.6,
    width: 19.3,
    height: 5.7
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 679.6,
    y: 275.1,
    width: 23.6,
    height: 63.1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 679.6,
    y: 202.6,
    width: 23.6,
    height: 53.8
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 679.6,
    y: 363.2,
    width: 23.6,
    height: 10.6
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 664.5,
    y: 71.8,
    width: 53.6,
    height: 25.8
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 653.8,
    y: 76.8,
    width: 7.2,
    height: 20.1
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 721.8,
    y: 76.8,
    width: 7.2,
    height: 20.1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 653.8,
    y: 182.5,
    width: 7.2,
    height: 20.1
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 721.8,
    y: 182.5,
    width: 7.2,
    height: 20.1
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 672.4,
    y: 65.3,
    width: 37.9,
    height: 6.5
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 674.5,
    y: 97.6,
    width: 33.6,
    height: 8
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 674.5,
    y: 176.1,
    width: 33.6,
    height: 6.5
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 664.5,
    y: 182.5,
    width: 53.6,
    height: 20.1
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 559.3,
    y: 105.6,
    width: 265.1,
    height: 70.4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M632.2,516.3a95.6,95.6,0,0,0,20.2,59.3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 810.8,
    cy: 394.1,
    rx: 42.3,
    ry: 42.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M750.7,516.3a8.61,8.61,0,0,0,10,6.9"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 564.8,
    y: 113,
    width: 4.7,
    height: 55.6
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 573.6,
    y: 113,
    width: 7.2,
    height: 55.6
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 585,
    y: 113,
    width: 9.8,
    height: 55.6
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 599,
    y: 113,
    width: 12.3,
    height: 55.6
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 615.5,
    y: 113,
    width: 14.8,
    height: 55.6
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 634.5,
    y: 113,
    width: 17.4,
    height: 55.6
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 656.1,
    y: 113,
    width: 19.9,
    height: 55.6
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 680.2,
    y: 113,
    width: 22.4,
    height: 55.6
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 813.6,
    y: 113,
    width: 4.7,
    height: 55.6
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 802.2,
    y: 113,
    width: 7.2,
    height: 55.6
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 788.2,
    y: 113,
    width: 9.8,
    height: 55.6
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 771.7,
    y: 113,
    width: 12.3,
    height: 55.6
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 752.7,
    y: 113,
    width: 14.8,
    height: 55.6
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 731.2,
    y: 113,
    width: 17.4,
    height: 55.6
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 707.1,
    y: 113,
    width: 19.9,
    height: 55.6
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 679.6,
    y: 51.6,
    width: 23.6,
    height: 13.8
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 688.6,
    y: 39,
    width: 5.7,
    height: 12.6
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M511.8,231.8h1.6a5.8,5.8,0,0,1,5.8,5.8h0v47.6a2.8,2.8,0,0,1-2.8,2.8h-7.5a2.8,2.8,0,0,1-2.8-2.8h0V237.6A5.66,5.66,0,0,1,511.8,231.8Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M547,235.2h0a7.38,7.38,0,0,1,7.4,7.4h0V257a7.38,7.38,0,0,1-7.4,7.4h0a7.38,7.38,0,0,1-7.4-7.4V242.7A7.47,7.47,0,0,1,547,235.2Z"
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 542.8,
    y1: 247.1,
    x2: 542.8,
    y2: 258.8
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 545.6,
    y1: 247.8,
    x2: 545.6,
    y2: 259.5
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 548.5,
    y1: 247.8,
    x2: 548.5,
    y2: 259.5
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 551.3,
    y1: 247.1,
    x2: 551.3,
    y2: 258.8
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M566.7,235.2h0a7.38,7.38,0,0,1,7.4,7.4V257a7.38,7.38,0,0,1-7.4,7.4h0a7.38,7.38,0,0,1-7.4-7.4h0V242.7a7.47,7.47,0,0,1,7.4-7.5Z"
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 562.5,
    y1: 247.1,
    x2: 562.5,
    y2: 258.8
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 565.3,
    y1: 247.8,
    x2: 565.3,
    y2: 259.5
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 568.1,
    y1: 247.8,
    x2: 568.1,
    y2: 259.5
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 571,
    y1: 247.1,
    x2: 571,
    y2: 258.8
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 520.4,
    y: 258.9,
    width: 105.7,
    height: 31.7
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 520.4,
    y: 216.2,
    width: 13.5,
    height: 22.9
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "520.4 230.8 512.6 283.5 520.4 283.5 520.4 230.8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M512.6,222.3h0a2.43,2.43,0,0,1,2.4,2.4v4.7a2.43,2.43,0,0,1-2.4,2.4h0a2.43,2.43,0,0,1-2.4-2.4h0v-4.7a2.31,2.31,0,0,1,2.4-2.4Z"
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 527.1,
    y1: 264.5,
    x2: 527.1,
    y2: 285.9
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 599.5,
    y: 249.1,
    width: 1.4,
    height: 9.8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 600.5,
    cy: 245.6,
    r: 4.2
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 599.2,
    y1: 246.4,
    x2: 600.5,
    y2: 245.6
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M530.2,239.3a3.13,3.13,0,0,1-6.2.8v-.9h6.2Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M527.1,242.8v6.6a5.85,5.85,0,0,0,5.7,5.8h0a5.88,5.88,0,0,0,3.6-1.3l3.1-2.5"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 588,
    y: 244.7,
    width: 2.8,
    height: 7.4
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M586.6,241.4h2.8a2.26,2.26,0,0,1,2.3,2.3h0a2.26,2.26,0,0,1-2.3,2.3h-2.8a2.26,2.26,0,0,1-2.3-2.3h0A2.26,2.26,0,0,1,586.6,241.4Z"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 613.6,
    y: 253.6,
    width: 7.7,
    height: 5.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 617.4,
    cy: 249,
    r: 6.4
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 520.4,
    y: 290.7,
    width: 7.2,
    height: 4.5
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 618.9,
    y: 290.7,
    width: 7.2,
    height: 4.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 543.9,
    cy: 275.1,
    r: 6
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 565.9,
    cy: 275.1,
    r: 6
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 587.8,
    cy: 275.1,
    r: 6
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 609.8,
    cy: 275.1,
    r: 6
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M583.4,243.7h0a4.8,4.8,0,0,0-4.8,4.8h0v9.8"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 582.5,
    y: 253.3,
    width: 25.4,
    height: 5.5
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 661,
    y: 265.7,
    width: 60.8,
    height: 9.3
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 707.1,
    y: 278.6,
    width: 19.3,
    height: 5.7
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 664.5,
    y: 256.4,
    width: 53.6,
    height: 9.3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 589,
    cy: 394,
    rx: 26.4,
    ry: 26.5
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 655.1,
    y: 373.9,
    width: 72.5,
    height: 7.9
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M727.6,381.8s1.2,15.2,11.3,24.6v18.7H643.8V406.4h0c10.2-9.4,11.3-24.6,11.3-24.6Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M669.9,381.8s-.8,15.2-7.3,24.6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M712.8,381.8s.8,15.2,7.3,24.6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M685.5,381.8s-.5,15.2-5,24.6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M697.3,381.8s.5,15.2,4.9,24.6"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 643.8,
    y: 406.4,
    width: 95.2,
    height: 18.7
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 614.6,
    y1: 406.4,
    x2: 643.8,
    y2: 406.4
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 739,
    y1: 406.4,
    x2: 770.5,
    y2: 406.4
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 620.5,
    y: 403.9,
    width: 19.7,
    height: 2.2
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 620.5,
    y: 381.8,
    width: 19.7,
    height: 2.2
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 743.1,
    y: 403.9,
    width: 19.7,
    height: 2.2
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 743.1,
    y: 381.9,
    width: 19.7,
    height: 2.2
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "746.3 379.9 759.7 379.9 759.7 409.3 746.3 415.3 746.3 379.9"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "637.3 402.6 637.3 415.3 623.9 409.3 623.9 379.9 637.3 379.9 637.3 402.6"
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 42.8,
    y1: 314.3,
    x2: 42.8,
    y2: 313.3
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 42.8,
    y1: 311.2,
    x2: 42.8,
    y2: 303.9
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 42.8,
    y1: 302.9,
    x2: 42.8,
    y2: 216.7
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 42.8,
    y1: 215.7,
    x2: 42.8,
    y2: 214.7
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "68.6 238.4 68.6 323.9 57.5 323.9 57.5 146 68.6 146 68.6 238.4"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "92.5 238.4 92.5 323.9 81.4 323.9 81.4 146 92.5 146 92.5 238.4"
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 42.8,
    y1: 142.4,
    y2: 142.4
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 361,
    y: 351.6,
    width: 144.8,
    height: 85
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 435.6,
    cy: 394.9,
    rx: 52.9,
    ry: 53.1
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 398.3,
    y1: 357.5,
    x2: 473.2,
    y2: 432.3
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 398.3,
    y1: 357.5,
    x2: 398.3,
    y2: 357.5
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 401.2,
    y1: 360.3,
    x2: 471.7,
    y2: 430.9
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 473.2,
    y1: 432.3,
    x2: 473.2,
    y2: 432.3
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 398.3,
    y1: 432.3,
    x2: 473.2,
    y2: 357.5
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 398.3,
    y1: 432.3,
    x2: 398.3,
    y2: 432.3
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 401.2,
    y1: 429.5,
    x2: 471.7,
    y2: 358.9
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 473.2,
    y1: 357.5,
    x2: 473.2,
    y2: 357.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 435.6,
    cy: 394.9,
    r: 17.7
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M400.1,532h13.4V420.6a7,7,0,0,1-6.8,5,6.64,6.64,0,0,1-6.6-5Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M393.1,533.3a13.8,13.8,0,0,1,27.6,0Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "410 424.6 442.7 402.2 428.6 387 401.9 413.9 410 424.6"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 435.6,
    cy: 394.5,
    r: 10.4
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 406.9,
    cy: 418.7,
    r: 6.9
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 502.9,
    y1: 352,
    x2: 502.9,
    y2: 352.1
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 502.9,
    y1: 358,
    x2: 502.9,
    y2: 433.1
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 502.9,
    y1: 436,
    x2: 502.9,
    y2: 436.1
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 522.8,
    y1: 352,
    x2: 522.8,
    y2: 352.1
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 522.8,
    y1: 358,
    x2: 522.8,
    y2: 433.1
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 522.8,
    y1: 436,
    x2: 522.8,
    y2: 436.1
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 508.2,
    y: 347.4,
    width: 9.2,
    height: 93.4
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 503.4,
    y: 350,
    width: 4.9,
    height: 88.1
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 517.5,
    y: 350,
    width: 4.8,
    height: 88.1
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 348.8,
    y1: 352,
    x2: 348.8,
    y2: 352.1
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 348.8,
    y1: 358,
    x2: 348.8,
    y2: 433.1
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 348.8,
    y1: 436,
    x2: 348.8,
    y2: 436.1
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 368.6,
    y1: 352,
    x2: 368.6,
    y2: 352.1
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 368.6,
    y1: 358,
    x2: 368.6,
    y2: 433.1
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 368.6,
    y1: 436,
    x2: 368.6,
    y2: 436.1
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 354.1,
    y: 347.4,
    width: 9.2,
    height: 93.4
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 349.2,
    y: 350,
    width: 4.9,
    height: 88.1
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 363.3,
    y: 350,
    width: 4.9,
    height: 88.1
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 455.8,
    y: 228.5,
    width: 2.8,
    height: 25
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M457.2,225.2h9.7a2.26,2.26,0,0,1,2.3,2.3h0a2.26,2.26,0,0,1-2.3,2.3h-9.7a2.26,2.26,0,0,1-2.3-2.3h0A2.26,2.26,0,0,1,457.2,225.2Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M384.7,251.8h68.5a17.52,17.52,0,0,1,17.5,17.5v4.5a17.52,17.52,0,0,1-17.5,17.5H384.7a17.52,17.52,0,0,1-17.5-17.5v-4.5A17.52,17.52,0,0,1,384.7,251.8Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "405.4 247.6 388.1 247.6 388.9 243.3 404.5 243.3 405.4 247.6"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 386.6,
    y: 248.1,
    width: 42.8,
    height: 3.7
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M434,251.7a3.13,3.13,0,1,1,6.2-.8h0v.8Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M437.1,245.5h4a2.48,2.48,0,0,0,2.5-2.5h0v-3.2"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 383.5,
    y: 291.3,
    width: 7.2,
    height: 4.5
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 447.3,
    y: 291.3,
    width: 7.2,
    height: 4.5
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 446.3,
    y: 241.6,
    width: 1.4,
    height: 9.8
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 447.3,
    cy: 238.1,
    r: 4.2
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 446,
    y1: 238.9,
    x2: 447.3,
    y2: 238.1
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M375.8,235.5h0a7.38,7.38,0,0,1,7.4-7.4h24.1a7.38,7.38,0,0,1,7.4,7.4h0a7.38,7.38,0,0,1-7.4,7.4H383.2a7.45,7.45,0,0,1-7.4-7.4Z"
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 386.6,
    y1: 239.7,
    x2: 409.1,
    y2: 239.7
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 387.5,
    y1: 236.9,
    x2: 410.4,
    y2: 236.9
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 387.5,
    y1: 234.1,
    x2: 410.4,
    y2: 234.1
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 386.6,
    y1: 231.2,
    x2: 409.1,
    y2: 231.2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M377.5,225.9h3.1a3.8,3.8,0,0,1,3.8,3.8v11.7a3.8,3.8,0,0,1-3.8,3.8h-3.1a3.8,3.8,0,0,1-3.8-3.8V229.7A3.8,3.8,0,0,1,377.5,225.9Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M407.5,206.8h20.1a1.69,1.69,0,0,1,1.7,1.7h0a1.69,1.69,0,0,1-1.7,1.7H407.5v-3.4Z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "425.4 226.3 411.4 226.3 410.4 213.7 426.4 213.7 425.4 226.3"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "411.4 206.2 425.4 206.2 426.4 213.3 410.4 213.3 411.4 206.2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M405.9,203.9h0a2.26,2.26,0,0,1,2.3,2.3v5.2a2.26,2.26,0,0,1-2.3,2.3h0a2.26,2.26,0,0,1-2.3-2.3v-5.2A2.33,2.33,0,0,1,405.9,203.9Z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "428.6 248.1 408.1 248.1 409.1 225.8 427.6 225.8 428.6 248.1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M429.3,208.5h5.3a2.48,2.48,0,0,1,2.5,2.5v40.8"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "484.2 160.2 457.4 160.2 458.7 153.6 482.9 153.6 484.2 160.2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M449.9,129.9h37.4a11.5,11.5,0,0,1,11.5,11.5h0a11.5,11.5,0,0,1-11.5,11.5H449.9a11.5,11.5,0,0,1-11.5-11.5h0A11.44,11.44,0,0,1,449.9,129.9Z"
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 455,
    y1: 148,
    x2: 489.9,
    y2: 148
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 456.4,
    y1: 143.6,
    x2: 491.9,
    y2: 143.6
  })), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 456.4,
    y1: 139.2,
    x2: 491.9,
    y2: 139.2
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 455,
    y1: 134.8,
    x2: 489.9,
    y2: 134.8
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M441,126.5h4.9a5.85,5.85,0,0,1,5.9,5.9v18.1a5.85,5.85,0,0,1-5.9,5.9H441a5.85,5.85,0,0,1-5.9-5.9V132.4A5.85,5.85,0,0,1,441,126.5Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M352,134h17.7a2.43,2.43,0,0,1,2.4,2.4h0v2.5a2.43,2.43,0,0,1-2.4,2.4h-5.8a2.37,2.37,0,0,0-2.4,2.4h0v1.9a2.43,2.43,0,0,0,2.4,2.4h5.8a2.43,2.43,0,0,1,2.4,2.4h0v2.5a2.43,2.43,0,0,1-2.4,2.4H352.5"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 366.6,
    cy: 144.6,
    r: 17.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalfunctionsFrancisTurbinemiv);
export default __webpack_public_path__ + "static/media/malfunctions_francis-turbine+miv.3517501f9436daecf7b8ae4e24a8c8c0.svg";
export { ForwardRef as ReactComponent };